import React, { Component } from 'react';
import LoadingSpinner from '../ui/LoadingSpinner';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from '../auth/AbEnvironment';
import { Tooltip } from '@mui/material';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  bindcard: {
    backgroundImage: 'url(/cards/bindcard-loading-2.png)',
    backgroundRepeat: 'no-repeat',
  },
  bindcardPlacement: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  bindcardMqCardPan: {
    position: 'relative',
    overflow: 'hidden',
  },
  bindcardMqCardCvv: {
    position: 'relative',
    overflow: 'hidden',
  },
  bindcardMqCardExp: {
    position: 'relative',
    overflow: 'hidden',
  },
  bindcardMqCardPanCopy: {
    position: 'relative',
    overflow: 'hidden',
  },
  bindcardMqCardCvvCopy: {
    position: 'relative',
    overflow: 'hidden',
  },
  bindcardMqCardExpCopy: {
    position: 'relative',
    overflow: 'hidden',
  },
  divInvisible: {
    visibility: 'hidden'
  },
  /* Screen size specific styles */
  [theme.breakpoints.up('xs')]: {
    bindcard: {
      width: 230,
      backgroundSize: 230,
      height: 180,
    },
    bindcardMqCardPan: {
      top: 57,
      left: 15,
      height: 30,
      width: 160,
    },
    bindcardMqCardPanCopy: {
      // top: 20,
      // left: 12,
      // height: 30
      top: -31,
      left: 15,
      height: 20,
      width: 160
    },
    bindcardMqCardCvv: {
      top: 26,
      left: 16,
      height: 30,
      width: 90,
    },
    bindcardMqCardCvvCopy: {
      top: -62,
      left: 16,
      height: 30,
      width: 30,
    },
    bindcardMqCardExp: {
      top: 56,
      left: 60,
      height: 30,
      width: 100,
    },
    bindcardMqCardExpCopy: {
      top: -32,
      left: 60,
      height: 30,
      width: 35
    },
    copyButton: {
      width: "20px",
      height: "20px",
      backgroundColor: 'transparent',
      border: 0
    },
    copyImage: {
      paddingleft: '0px',
      height: "12px",
    }
  },
  [theme.breakpoints.up('sm')]: {
    bindcard: {
      width: 380,
      backgroundSize: 380,
      height: 240,
    },
    bindcardMqCardPan: {
      top: 100,
      left: 24,
      height: 30,
      width: 280,
    },
    bindcardMqCardPanCopy: {
      top:14,
      left:24,
      height: 30,
      width: 280
    },
    bindcardMqCardCvv: {
      top: 88,
      left: 25,
      height: 30,
      width: 300,
    },
    bindcardMqCardCvvCopy: {
      top: 2,
      left: 25,
      height: 30,
      width: 40,
    },
    bindcardMqCardExp: {
      top: 118,
      left: 98,
      height: 30,
      width: 300,
    },
    bindcardMqCardExpCopy: {
      top: 32,
      left: 98,
      height: 30,
      width: 66
    },
    copyButton: {
      width: "20px",
      height: "20px",
      backgroundColor: 'transparent',
      border: 0
    },
    copyImage: {
      paddingleft: '0px',
      height: "16px",
    }
  }
});

class BindCardPresentmentII extends Component {

  small = window.innerWidth < 600;
  node = null;

  constructor(props) {
    super(props);

    //used for establishing ref for node
    this.wrapper = React.createRef();

    const { getUniquePresentmentIndex } = this.props.auth;
    let i = getUniquePresentmentIndex();

    this.state = {
      bindCardLoading: null,
      bcIndex: i
    }

    // .bind() creates a NEW instance of the target function
    // store this instance in a variable and use in componentDidMount() and componentWillUnmount()
    this.onResizeBound = this._onResize.bind(this);
    // if you code it this way:
    //  window.addEventListener('resize', this._onResize.bind(this));
    //  window.removeEventListener('resize', this._onResize.bind(this));
    // this is wrong! as mentioned above .bind() creates a NEW instance of the target function
    // therefore the removeEventListener() is not removing the original reference on the addEventListener()
    // and the event and handler function is executing on other pages
  }

  componentDidMount() {
    if (this.props.parentRef != null) {
      this.props.parentRef(this);
    }

    if (this.props.cardToken != null) {
      this._viewBindcard(this.props.bcId, this.props.cardToken);
    }

    this.node = this.wrapper.current;
    window.addEventListener('resize', this.onResizeBound);
  }

  componentWillUnmount() {
    if (this.props.parentRef != null) {
      this.props.parentRef(undefined);
    }
    this._cleanupBindcard();
    window.removeEventListener('resize', this.onResizeBound);
  }

  render() {
    const classes = this.props.classes;

    let i = this.state.bcIndex;
    let virtual_card_container_id = "virtual-card-container-" + i;
    let mq_card_pan_id = "mq-card-pan-" + i;
    let mq_card_exp_id = "mq-card-exp-" + i;
    let mq_card_cvv_id = "mq-card-cvv-" + i;
    let mq_card_pan_id_copy = "mq-card-pan-copy-" + i;
    let mq_card_exp_id_copy = "mq-card-exp-copy-" + i;
    let mq_card_cvv_id_copy = "mq-card-cvv-copy-" + i;

    /**
     * DO NOT REMOVE this comment
     * This is what a white button in the copy button area would be coded as: 
     * <button className={classes.copyButton} id={mq_card_pan_id_copy}><img className={classes.copyImage} src="/images/content_copy_w_24x24.png" alt="Copy card number"/></button>
     **/
    return (
      <div ref={this.wrapper}>
        <div className={'appbind-bindcard ' + classes.bindcardPlacement}>
          <div id={virtual_card_container_id}>
            <div className={classes.bindcard}>
               {this.state.bindCardLoading &&
                <div style={{ paddingTop: 30 }}>
                  <LoadingSpinner />
                </div>
              }
              <div className={(this.state.bindCardLoading ? classes.divInvisible : '')}>
                  <div className={classes.bindcardMqCardPan} id={mq_card_pan_id}></div>
                  <div className={classes.bindcardMqCardExp} id={mq_card_exp_id}></div>
                  <div className={classes.bindcardMqCardCvv} id={mq_card_cvv_id}></div>
                  {this.props.showCopyButtons !== false &&
                  <React.Fragment>
                  <div id='copy-pan-container' className={classes.bindcardMqCardPanCopy}>
                    <Tooltip title="Click to copy card number">
                      <button className={classes.copyButton} id={mq_card_pan_id_copy}></button>
                    </Tooltip>
                  </div>
                  <div id='copy-exp-container' className={classes.bindcardMqCardExpCopy}>
                    <Tooltip title="Click to copy card expiration">
                     <button className={classes.copyButton} id={mq_card_exp_id_copy}></button>
                     </Tooltip>
                  </div>
                  <div id='copy-cvv-container' className={classes.bindcardMqCardCvvCopy}>
                    <Tooltip title="Click to copy card security code">
                      <button className={classes.copyButton} id={mq_card_cvv_id_copy}></button>
                    </Tooltip>
                  </div>
                  </React.Fragment>
                  }
               </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onResize() {
    //console.log( 'small=' + this.small + ', width=' + window.innerWidth );
    if (this.small && window.innerWidth >= 600) {
      this.small = false;
      this._reloadBindCard();

    } else if (!this.small && window.innerWidth < 600) {
      this.small = true;
      this._reloadBindCard();
    }
  }

  _reloadBindCard() {
    // don't call _viewBindcard (marqeta) if the previous call did not complete
    if (this.state.bindCardLoading === false) {
      let i = this.state.bcIndex;
      //let virtual_card_container_id = "virtual-card-container-" + i;
      let mq_card_pan_id = "mq-card-pan-" + i;
      let mq_card_exp_id = "mq-card-exp-" + i;
      let mq_card_cvv_id = "mq-card-cvv-" + i;
      let mq_card_pan_id_copy = "mq-card-pan-copy-" + i;
      let mq_card_exp_id_copy = "mq-card-exp-copy-" + i;
      let mq_card_cvv_id_copy = "mq-card-cvv-copy-" + i;
  
      if (this.node && this.props.cardToken != null) {

        // clear / remove any past elements rendered by _viewBindcard (marqeta)
        let div1Copy;
        try {
          div1Copy = this.node.querySelector('div#' + mq_card_pan_id_copy);
          let iframe1Copy = this.node.querySelector('div#' + mq_card_pan_id_copy + ' iframe');
          div1Copy.removeChild(iframe1Copy);
        } catch (e) {
          if (div1Copy) {
            div1Copy.innerHTML = "";
          }
        }
        let div2Copy;
        try {
          div2Copy = this.node.querySelector('div#' + mq_card_exp_id_copy);
          let iframe2Copy = this.node.querySelector('div#' + mq_card_exp_id_copy + ' iframe');
          div2Copy.removeChild(iframe2Copy);
        } catch (e) {
          if (div2Copy) {
            div2Copy.innerHTML = "";
          }
        }
        let div3Copy;
        try {
          div3Copy = this.node.querySelector('div#' + mq_card_cvv_id_copy);
          let iframe3Copy = this.node.querySelector('div#' + mq_card_cvv_id_copy + ' iframe');
          div3Copy.removeChild(iframe3Copy);
        } catch (e) {
          if (div3Copy) {
            div3Copy.innerHTML = "";
          }
        }

        let div1;
        try {
          div1 = this.node.querySelector('div#' + mq_card_pan_id);
          let iframe1 = this.node.querySelector('div#' + mq_card_pan_id + ' iframe');
          div1.removeChild(iframe1);
        } catch (e) {
          if (div1) {
            div1.innerHTML = "";
          }
        }
        let div2;
        try {
          div2 = this.node.querySelector('div#' + mq_card_exp_id);
          let iframe2 = this.node.querySelector('div#' + mq_card_exp_id + ' iframe');
          div2.removeChild(iframe2);
        } catch (e) {
          if (div2) {
            div2.innerHTML = "";
          }
        }
        let div3;
        try {
          div3 = this.node.querySelector('div#' + mq_card_cvv_id);
          let iframe3 = this.node.querySelector('div#' + mq_card_cvv_id + ' iframe');
          div3.removeChild(iframe3);
        } catch (e) {
          if (div3) {
            div3.innerHTML = "";
          }
        }

        // call _viewBindcard (marqeta)
        this._viewBindcard(this.props.bcId, this.props.cardToken);
      }
    }
  }

  _cleanupBindcard() {
    if (window.marqeta) {
      window.marqeta.destroy();
    }
  }

  _viewBindcard(bcId, extBcId) {
    const { callPartnerApi, logError } = this.props.auth;
    let i = this.state.bcIndex;

    //let virtual_card_container_id = "virtual-card-container-" + i;
    let mq_card_pan_id = "mq-card-pan-" + i;
    let mq_card_exp_id = "mq-card-exp-" + i;
    let mq_card_cvv_id = "mq-card-cvv-" + i;
    let mq_card_pan_id_copy = "mq-card-pan-copy-" + i;
    let mq_card_exp_id_copy = "mq-card-exp-copy-" + i;
    let mq_card_cvv_id_copy = "mq-card-cvv-copy-" + i;

    this.setState({ bindCardLoading: true });
    let component = this;
    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "getBindCardAccessToken",
      params: {
        pJwt:       aPjwt,
        bindCardId: bcId,
        extBcId:    extBcId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then(response => {
      return response.json();
    }).then(data => {
      let theToken = data.token;

      if (this.props.showCopyButtons !== false) {
        
        window.marqeta.bootstrap({
          "clientAccessToken": theToken,
          "component": {
            "showPan": {
              "cardPan": {
                "domId": mq_card_pan_id,
                "format": true,
                "styles": {
                  "span": {
                    "color": "white",
                    "font-family": "Arial, Helvetica, sans-serif",
                    "font-weight": "normal",
                    "letter-spacing": "2px",
                    "font-size": window.innerWidth >= 600 ? "24px" : "12px"
                  }
                }
              },
              "copyCardPan": {
                "domId": mq_card_pan_id_copy,
                "mode": "transparent"
              },
              "cardExp": {
                "domId": mq_card_exp_id,
                "format": true,
                "styles": {
                  "span": {
                    "color": "white",
                    "font-family": "Arial, Helvetica, sans-serif",
                    "font-weight": "normal",
                    "letter-spacing": "2px",
                    "font-size": window.innerWidth >= 600 ? "24px" : "12px"
                  }
                }
              },
              "copyCardExp": {
                "domId": mq_card_exp_id_copy,
                "mode": "transparent",
              },
              "cardCvv": {
                "domId": mq_card_cvv_id,
                "styles": {
                  "span": {
                    "color": "white",
                    "font-family": "Arial, Helvetica, sans-serif",
                    "font-weight": "normal",
                    "letter-spacing": "2px",
                    "font-size": window.innerWidth >= 600 ? "24px" : "12px"
                  }
                }
              },
              "copyCardCvv": {
                "domId": mq_card_cvv_id_copy,
                "mode": "transparent"
              }
            }
          },
          "callbackEvents": {
            "onSuccess": () => {
              //console.log("Success!");
              component.setState({ bindCardLoading: false });
            },
            "onFailure": error => {
              //console.error("error: " + error);
              component.setState({ bindCardLoading: false });
            }
          }
        }).catch((error) => {
          //eating here - exceptions were being thrown when resizing.  They seem to be all benign
        });
  
      } else {
        window.marqeta.bootstrap({
          "clientAccessToken": theToken,
          "component": {
            "showPan": {
              "cardPan": {
                "domId": mq_card_pan_id,
                "format": true,
                "styles": {
                  "span": {
                    "color": "white",
                    "font-family": "Arial, Helvetica, sans-serif",
                    "font-weight": "normal",
                    "letter-spacing": "2px",
                    "font-size": window.innerWidth >= 600 ? "24px" : "12px"
                  }
                }
              },
              "cardExp": {
                "domId": mq_card_exp_id,
                "format": true,
                "styles": {
                  "span": {
                    "color": "white",
                    "font-family": "Arial, Helvetica, sans-serif",
                    "font-weight": "normal",
                    "letter-spacing": "2px",
                    "font-size": window.innerWidth >= 600 ? "24px" : "12px"
                  }
                }
              },
              "cardCvv": {
                "domId": mq_card_cvv_id,
                "styles": {
                  "span": {
                    "color": "white",
                    "font-family": "Arial, Helvetica, sans-serif",
                    "font-weight": "normal",
                    "letter-spacing": "2px",
                    "font-size": window.innerWidth >= 600 ? "24px" : "12px"
                  }
                }
              }
            }
          },
          "callbackEvents": {
            "onSuccess": () => {
              //console.log("Success!");
              component.setState({ bindCardLoading: false });
            },
            "onFailure": error => {
              //console.error("error: " + error);
              component.setState({ bindCardLoading: false });
            }
          }
        }).catch((error) => {
          //eating here - exceptions were being thrown when resizing.  They seem to be all benign
        });
  
      }
    })
      .catch(error => {
        logError('Error in BindCardPresentmentII' + error)
        // console.log("Error: " + error);
      });
  }

}

//export default BindCardPresentmentII;
export default withStyles(styleSheet)(BindCardPresentmentII);
